import React from "react";
import {
  FaRegChartBar,
  FaBullseye,
  FaUsers,
  FaProjectDiagram,
  FaLightbulb,
  FaRocket,
  FaClipboardList
} from "react-icons/fa";

import MarketOppVisual from "../assets/images/service_market_opp.png";
import CompIntelVisual from "../assets/images/service_comp_intel.png";
import CustomerVoiceVisual from "../assets/images/service_customer_voice.png";
import SupplierValueVisual from "../assets/images/service_supplier_value.png";
import TechInnovVisual from "../assets/images/service_tech_innov.png";
import GTMGrowthVisual from "../assets/images/service_gtm_growth.png";
import CustomResearchVisual from "../assets/images/service_custom_research.png";
import CustomResearchSecondaryVisual from "../assets/images/research_capabilities_noface.jpg";
import MarketSizeForecastVisual from "../assets/images/Market_size_and_forecast_estimates.jpg";
import TamSamSomVisual from "../assets/images/TAM_SAM_SOM_analysis_market_opportunity_assessment.jpg";
import MarketAttractivenessVisual from "../assets/images/Market_attractiveness_assessment_market_opportunity_assessment.jpg";
import OpportunityMappingVisual from "../assets/images/mapping_across_products_applications_geographies.jpg";
import CountryRegionalVisual from "../assets/images/Country_regional_comparison_market_opportunity_assessment.jpg";
import GrowthDriverTrendVisual from "../assets/images/Growth_driver_trend_analysis_market-opportunity-assessment.jpg";
import ExecutiveReadyVisual from "../assets/images/Executive_ready_presentations.jpg";
import ExcelAnalyticalVisual from "../assets/images/Excel_based_analytical_models_supporting_datasets_market-opportunity-assessment.jpg";
// Competitive Intelligence Visuals
import CompetitorProfilesCardVisual from "../assets/images/Competitor_profiles.jpg";
import CompetitiveBenchmarkingVisual from "../assets/images/Competitive_benchmarking_reports.jpg";
import ProductPortfolioVisual from "../assets/images/Product_portfolio_comparisons.jpg";
import PricingPositioningVisual from "../assets/images/Pricing_positioning_analysis.jpg";
import SwotAssessmentsVisual from "../assets/images/SWOT_assessments.png";
import StrategicActivityVisual from "../assets/images/Strategic_activity_trackers.jpg";
import CompetitiveLandscapeVisual from "../assets/images/Competitive_landscape_reports_competitive-intelligence.jpg";
import ExecPresentationsAnalyticalVisual from "../assets/images/Executive_presentations_analytical_datasets.jpg";
import CompetitorProfilesVisual from "../assets/images/Competitor_profiles.png";

// GTM Growth Strategy Visuals
import StrategicMilestoneVisual from "../assets/images/Strategic_milestone_planning.jpg";
import StructuredGrowthVisual from "../assets/images/Structured_growth_roadmaps.jpg";
import ChannelPartnershipVisual from "../assets/images/Channel_partnership_assessments.jpg";
import ValuePropositionVisual from "../assets/images/Value_proposition_development.jpg";
import TargetSegmentVisual from "../assets/images/Target_segment_prioritization.jpg";
import MarketEntryVisual from "../assets/images/Market_entry_strategy_frameworks.jpg";

// Supplier & Value Chain Visuals
import QualifiedSupplierVisual from "../assets/images/Qualified_supplier_databases.jpg";
import SupplierBenchmarkingVisual from "../assets/images/Supplier_benchmarking_reports.jpg";
import ManufacturingLandscapeVisual from "../assets/images/Manufacturing_landscape_assessments.jpg";
import ValueChainMapVisual from "../assets/images/Value_chain_maps.jpg";
import CountrySourcingVisual from "../assets/images/Country_sourcing_comparisons.jpg";
import SupplyChainRiskVisual from "../assets/images/Supply_chain_risk_assessments.jpg";
import ExecutivePresentationsVisual from "../assets/images/Executive_presentations.jpg";
import ExcelSupplierDatasetsVisual from "../assets/images/Excel_based_supplier_datasets.jpg";

// Customer Voice Visuals
import OnlineSurveysVisual from "../assets/images/Online_surveys.jpg";
import TelephoneSurveysVisual from "../assets/images/Telephone_surveys.jpg";
import FaceToFaceVisual from "../assets/images/Face_to_face_interviews.jpg";
import InDepthVisual from "../assets/images/In_depth_interviews.jpg";
import FocusGroupVisual from "../assets/images/Focus_group_discussions.jpg";
import ExpertInterviewsVisual from "../assets/images/Expert_interviews.jpg";
import OnlineCommunitiesVisual from "../assets/images/Online_communities_feedback_platforms.jpg";

// Technology & Innovation Visuals
import ExecutiveInnovationVisual from "../assets/images/Executive_innovation_briefings.jpg";
import InvestmentFundingVisual from "../assets/images/Investment_funding_outlooks.jpg";
import TechAdoptionVisual from "../assets/images/Technology_adoption_forecasting.jpg";
import PatentActivityVisual from "../assets/images/Patent_R&D_activity_tracking.jpg";
import InnovationEcosystemVisual from "../assets/images/Innovation_ecosystem_mapping.jpg";
import EmergingTechVisual from "../assets/images/Emerging_technology_commercialization_assessments.jpg";

export const servicesData = [
  {
    slug: "market-opportunity-assessment",
    title: "Market & Opportunity Assessment",
    description: "Identify the Right Markets. Prioritize the Right Opportunities. Growth opportunities are everywhere, but not every opportunity aligns with your business goals. Whether you're evaluating a new geography, exploring an adjacent market, launching a product, or assessing future demand, making the right decision starts with understanding the market. Researchwire helps organizations evaluate market potential, identify high-growth opportunities, and compare markets through customized research designed to answer their specific business questions.",
    shortDescription: "Evaluate market potential and uncover high-growth opportunities. We help you compare geographies, analyze market dynamics, and prioritize the right segments for strategic expansion.",
    icon: <FaRegChartBar size={24} />,
    image: MarketOppVisual,
    whatWeGive: "Researchwire helps organizations evaluate market potential, identify high-growth opportunities, and compare markets through customized research designed to answer their specific business questions.",
    heroCtaText: "Talk to Our Experts",
    bentoGridTitle: "What We Assess ?",
    closingSection: {
      title: "From Market Intelligence to Opportunity Decisions",
      description: "We combine extensive secondary research, targeted primary research where required, and rigorous analytical frameworks to deliver intelligence that is relevant, objective, and aligned with your goals.",
      ctaText: "Let's Discuss Your Market Opportunity",
      ctaLink: "/contact-us"
    },
    overviewPoints: [
      {
        title: "Business Questions We Help Answer",
        text: "Organizations engage us when they need clarity on questions such as:",
        bullets: [
          "How large is the market today, and how is it expected to evolve?",
          "Which countries or regions should we prioritize for expansion?",
          "Which applications, industries, or customer segments offer the greatest growth potential?",
          "Where are the untapped opportunities within an existing market?",
          "What factors are driving market growth and changing market dynamics?",
          "Which opportunities align best with our business objectives?"
        ]
      }
    ],
    outputsSection: {
      title: "What the Assessment Delivers",
      description: "The assessment provides the market evidence and analysis needed to evaluate attractiveness, compare opportunities, and prioritize where to focus.",
      items: [
        { title: "Market size and forecast estimates", image: MarketSizeForecastVisual },
        { title: "TAM, SAM, and SOM analysis", image: TamSamSomVisual },
        { title: "Market attractiveness assessment", image: MarketAttractivenessVisual },
        { title: "Opportunity mapping across products, applications, and geographies", image: OpportunityMappingVisual },
        { title: "Country and regional comparison", image: CountryRegionalVisual },
        { title: "Growth driver and trend analysis", image: GrowthDriverTrendVisual },
        { title: "Executive-ready presentations", image: ExecutiveReadyVisual },
        { title: "Excel-based analytical models and supporting datasets", image: ExcelAnalyticalVisual }
      ]
    },
    detailedContent: [
      {
        title: "Market Potential",
        description: "Estimate market size, growth outlook, demand trends, and future opportunities across products, applications, industries, and customer segments."
      },
      {
        title: "Opportunity Identification",
        description: "Identify high-potential markets, emerging applications, underserved segments, and evolving demand to uncover new avenues for growth."
      },
      {
        title: "Country & Regional Assessment",
        description: "Compare countries and regions based on market demand, industry maturity, regulatory landscape, infrastructure, trade environment, and investment activity."
      },
      {
        title: "Market Dynamics",
        description: "Analyze the drivers, restraints, trends, technological developments, and regulatory changes shaping market evolution."
      },
      {
        title: "Opportunity Prioritization",
        description: "Compare multiple opportunities using structured evaluation criteria to identify the markets, segments, or regions that offer the strongest long-term potential."
      }
    ]
  },
  {
    slug: "competitive-intelligence",
    title: "Competitive Intelligence",
    description: "See Beyond the Competition. Make Better Strategic Decisions. Competitors shape markets through new products, pricing strategies, partnerships, investments, acquisitions, and technological advancements. Understanding these developments is essential for making informed business decisions and maintaining a competitive edge.",
    shortDescription: "Monitor competitor activities, benchmark performance, and anticipate market movements before they become industry trends.",
    icon: <FaBullseye size={24} />,
    image: CompIntelVisual,
    whatWeGive: "Researchwire delivers customized competitive intelligence that helps organizations monitor competitor activities, benchmark performance, identify strategic shifts, and anticipate market movements before they become industry trends.",
    heroCtaText: "Talk to Our Experts",
    bentoGridTitle: "Competitive Intelligence Built Around Your Objectives",
    closingSection: {
      title: "From Information to Competitive Advantage",
      description: "Competitive intelligence is not about collecting large volumes of information. The value lies in identifying what matters, validating findings across multiple sources, connecting developments, and translating them into meaningful business insights.",
      ctaText: "Let's Discuss Your Competitive Intelligence Requirements",
      ctaLink: "/contact-us"
    },
    overviewPoints: [
      {
        title: "What Do You Need to Know About Your Competitors?",
        text: "Whether you're entering a new market, launching a product, or strengthening your market position, competitive intelligence helps answer critical questions such as:",
        bullets: [
          "Who are our direct, indirect, and emerging competitors?",
          "How do competitors differentiate themselves?",
          "What products, services, or technologies are they introducing?",
          "Where are they investing, expanding, or forming partnerships?",
          "How do our capabilities compare with industry leaders?",
          "What opportunities or threats should we be preparing for?"
        ]
      }
    ],
    outputsSection: {
      title: "The Insights We Deliver",
      description: "We translate competitive activity and market developments into structured intelligence that supports strategic planning and competitive positioning.",
      items: [
        { title: "Competitor profiles", image: CompetitorProfilesCardVisual },
        { title: "Competitive benchmarking reports", image: CompetitiveBenchmarkingVisual },
        { title: "Product and portfolio comparisons", image: ProductPortfolioVisual },
        { title: "Pricing and positioning analysis", image: PricingPositioningVisual },
        { title: "SWOT assessments", image: SwotAssessmentsVisual },
        { title: "Strategic activity trackers", image: StrategicActivityVisual },
        { title: "Competitive landscape reports", image: CompetitiveLandscapeVisual },
        { title: "Executive presentations and analytical datasets", image: ExecPresentationsAnalyticalVisual }
      ]
    },
    detailedContent: [
      {
        title: "Competitor Identification & Profiling",
        description: "Build a comprehensive view of the organizations competing within your market, including their business overview, product portfolio, geographic presence, customer focus, and strategic positioning.",
        image: CompetitorProfilesVisual
      },
      {
        title: "Competitive Benchmarking",
        description: "Compare competitors across capabilities, products, pricing approaches, innovation, manufacturing footprint, digital presence, sustainability initiatives, partnerships, and other business parameters relevant to your objectives."
      },
      {
        title: "Strategic Activity Monitoring",
        description: "Track product launches, acquisitions, investments, capacity expansions, collaborations, leadership changes, and other developments that influence competitive positioning."
      },
      {
        title: "Innovation & Technology Tracking",
        description: "Monitor patent activity, R&D initiatives, technology adoption, startup collaborations, and emerging innovations shaping the future competitive landscape."
      },
      {
        title: "Market Position & Differentiation",
        description: "Understand how competitors position themselves, communicate value, target customers, and build competitive advantage across different markets."
      }
    ]
  },
  {
    slug: "customer-voice-research",
    title: "Customer & Voice of Market Research",
    description: "Understand the People Behind Every Business Decision. The success of a product, service, or strategy ultimately depends on the people it is built for. Understanding customer expectations, experiences, preferences, and purchasing behavior enables organizations to make decisions grounded in real market feedback rather than assumptions.",
    shortDescription: "Capture meaningful insights across the customer journey and translate them into actionable business intelligence.",
    icon: <FaUsers size={24} />,
    image: CustomerVoiceVisual,
    whatWeGive: "Researchwire designs and executes customized customer research programs that help organizations capture meaningful insights across the customer journey and translate them into actionable business intelligence.",
    heroCtaText: "Talk to Our Experts",
    bentoGridTitle: "Research Areas",
    closingSection: {
      title: "From Customer Feedback to Business Action",
      description: "Collecting responses is only the beginning. The value comes from identifying patterns, understanding the reasons behind customer behavior, and translating findings into practical business recommendations.",
      ctaText: "Let's Understand Your Customers Better",
      ctaLink: "/contact-us"
    },
    overviewPoints: [
      {
        title: "Every Business Has Questions Only Customers Can Answer",
        text: "We help organizations understand:",
        bullets: [
          "What influences customer purchasing decisions?",
          "How do customers perceive our products or brand?",
          "Which product features matter the most?",
          "Why are customers choosing competitors?",
          "How satisfied are customers with their overall experience?",
          "What unmet needs or expectations exist within the market?"
        ]
      }
    ],
    outputsSection: {
      title: "How We Capture Market Feedback",
      description: "Depending on the research objective, audience, geography, and business question, we use the approach best suited to generating reliable customer and market feedback.",
      items: [
        { title: "Online surveys", image: OnlineSurveysVisual },
        { title: "Telephone surveys (CATI)", image: TelephoneSurveysVisual },
        { title: "Face-to-face interviews", image: FaceToFaceVisual },
        { title: "In-depth interviews (IDIs)", image: InDepthVisual },
        { title: "Focus group discussions (FGDs)", image: FocusGroupVisual },
        { title: "Expert interviews", image: ExpertInterviewsVisual },
        { title: "Online communities and feedback platforms", image: OnlineCommunitiesVisual }
      ]
    },
    detailedContent: [
      {
        title: "Customer Satisfaction Studies",
        description: "Measure customer satisfaction, identify service gaps, evaluate overall experience, and uncover opportunities for continuous improvement."
      },
      {
        title: "Voice of Customer Research",
        description: "Capture customer opinions, expectations, challenges, and preferences to understand evolving market needs."
      },
      {
        title: "Product & Concept Testing",
        description: "Evaluate customer reactions to new products, concepts, features, packaging, messaging, or pricing before market introduction."
      },
      {
        title: "Customer Needs Assessment",
        description: "Identify unmet needs, buying motivations, usage patterns, and decision-making criteria across target customer segments."
      },
      {
        title: "Brand Perception Research",
        description: "Understand brand awareness, perception, positioning, reputation, and competitive preference among existing and potential customers."
      }
    ]
  },
  {
    slug: "supplier-value-chain",
    title: "Supplier & Value Chain Intelligence",
    description: "Build a Stronger, More Resilient Supply Network. Finding the right supplier goes beyond identifying companies that manufacture a product. It requires understanding capabilities, production capacity, certifications, geographic footprint, supply chain risks, and long-term strategic fit.",
    shortDescription: "Identify, evaluate, and benchmark suppliers while providing visibility across the value chain to support informed sourcing decisions.",
    icon: <FaProjectDiagram size={24} />,
    image: SupplierValueVisual,
    whatWeGive: "Researchwire helps organizations identify, evaluate, and benchmark suppliers while providing visibility across the value chain to support informed sourcing and procurement decisions.",
    heroCtaText: "Talk to Our Experts",
    bentoGridTitle: "Our Supplier Intelligence Capabilities",
    closingSection: {
      title: "Supporting Smarter Supply Chain Decisions",
      description: "Our role is to provide reliable intelligence that helps organizations move beyond supplier lists and build sourcing strategies based on capability, resilience, and business fit.",
      ctaText: "Let's Strengthen Your Supplier Strategy",
      ctaLink: "/contact-us"
    },
    overviewPoints: [
      {
        title: "From Supplier Discovery to Strategic Sourcing",
        text: "Whether you're qualifying new suppliers, expanding into new regions, reducing supply chain risk, or optimizing your supplier base, we help you build a clearer picture of your sourcing ecosystem. Our research supports decisions such as:",
        bullets: [
          "Identifying manufacturers with specific production capabilities",
          "Evaluating suppliers across multiple qualification criteria",
          "Comparing sourcing opportunities across countries and regions",
          "Understanding upstream and downstream value chains",
          "Diversifying supplier networks to improve resilience",
          "Monitoring supplier developments and industry changes"
        ]
      }
    ],
    outputsSection: {
      title: "Insights That Support Better Procurement Decisions",
      description: "Our research provides the supplier, manufacturing, value chain, and risk intelligence needed to evaluate sourcing options and strengthen procurement decisions.",
      items: [
        { title: "Qualified supplier databases", image: QualifiedSupplierVisual },
        { title: "Supplier benchmarking reports", image: SupplierBenchmarkingVisual },
        { title: "Manufacturing landscape assessments", image: ManufacturingLandscapeVisual },
        { title: "Value chain maps", image: ValueChainMapVisual },
        { title: "Country sourcing comparisons", image: CountrySourcingVisual },
        { title: "Supply chain risk assessments", image: SupplyChainRiskVisual },
        { title: "Executive presentations", image: ExecutivePresentationsVisual },
        { title: "Excel-based supplier datasets", image: ExcelSupplierDatasetsVisual }
      ]
    },
    detailedContent: [
      {
        title: "Supplier Identification",
        description: "Identify manufacturers, OEMs, distributors, contract manufacturers, technology providers, and other ecosystem participants based on your sourcing requirements."
      },
      {
        title: "Supplier Assessment & Qualification",
        description: "Evaluate suppliers across manufacturing capabilities, production capacity, certifications, quality standards, technology expertise, geographic presence, export capabilities, and strategic fit."
      },
      {
        title: "Value Chain Mapping",
        description: "Map the complete industry value chain to understand raw material suppliers, component manufacturers, OEMs, distributors, channel partners, and end-use industries."
      },
      {
        title: "Country & Manufacturing Landscape",
        description: "Compare manufacturing ecosystems across regions based on industrial infrastructure, labor availability, regulatory environment, trade policies, logistics, and investment attractiveness."
      },
      {
        title: "Supply Chain Risk Assessment",
        description: "Identify potential sourcing risks, supplier concentration, geopolitical considerations, operational dependencies, and alternative sourcing opportunities."
      }
    ]
  },
  {
    slug: "technology-innovation",
    title: "Technology & Innovation Intelligence",
    description: "Understand the Markets Shaped by Emerging Technologies. Emerging technologies are transforming industries, creating new business models, and opening opportunities for growth. Organizations need clarity on market readiness, commercial potential, industry adoption, and competitive activity.",
    shortDescription: "Evaluate technology-driven markets, monitor innovation trends, and identify opportunities that support informed business decisions.",
    icon: <FaLightbulb size={24} />,
    image: TechInnovVisual,
    whatWeGive: "Researchwire helps organizations evaluate technology-driven markets, monitor innovation trends, and identify opportunities that support informed business and investment decisions.",
    heroCtaText: "Talk to Our Experts",
    bentoGridTitle: "How We Help You Navigate Technology-Driven Markets",
    closingSection: {
      title: "Delivering Market Intelligence for Innovation Decisions",
      description: "Rather than focusing solely on the technology, we help organizations understand the broader market environment in which it is developing and where the most promising opportunities exist.",
      ctaText: "Let's Explore the Next Opportunity",
      ctaLink: "/contact-us"
    },
    overviewPoints: [
      {
        title: "From Technology Trends to Market Opportunities",
        text: "Our research helps organizations understand:",
        bullets: [
          "Which emerging technologies are influencing our industry?",
          "How mature is the market for a particular technology?",
          "Which industries and applications are driving adoption?",
          "Who are the companies leading innovation and commercialization?",
          "Where are investments and research activities accelerating?",
          "How will evolving technologies influence future market opportunities?"
        ]
      }
    ],
    outputsSection: {
      title: "What the Research Can Deliver",
      description: "The research translates technology developments and innovation activity into market intelligence that helps organizations evaluate commercial potential, adoption, and future opportunities.",
      items: [
        { title: "Emerging technology commercialization assessments", image: EmergingTechVisual },
        { title: "Innovation ecosystem mapping", image: InnovationEcosystemVisual },
        { title: "Patent and R&D activity tracking", image: PatentActivityVisual },
        { title: "Technology adoption forecasting", image: TechAdoptionVisual },
        { title: "Investment and funding outlooks", image: InvestmentFundingVisual },
        { title: "Executive innovation briefings", image: ExecutiveInnovationVisual }
      ]
    },
    detailedContent: [
      {
        title: "Emerging Technology Market Assessment",
        description: "Evaluate commercial landscape, market maturity, growth potential, industry adoption, and future outlook."
      },
      {
        title: "Innovation Ecosystem Analysis",
        description: "Identify startups, technology developers, research institutions, universities, investors, incubators, accelerators, and strategic collaborations shaping innovation."
      },
      {
        title: "Technology Adoption & Commercialization",
        description: "Understand technology adoption across industries, commercialization pathways, barriers to adoption, and future market potential."
      },
      {
        title: "Patent & Innovation Trend Analysis",
        description: "Track patent activity, research trends, innovation focus areas, and technology developments to understand how innovation is evolving."
      },
      {
        title: "Investment & Market Outlook",
        description: "Analyze investment activity, funding trends, regulatory developments, government initiatives, and industry movements influencing technology-driven markets."
      }
    ]
  },
  {
    slug: "gtm-growth-strategy",
    title: "Go-to-Market & Growth Strategy",
    description: "Turn Market Intelligence into Growth. A successful market entry or growth strategy requires more than identifying an opportunity. It requires understanding where to compete, who to target, how to position your offering, and the most effective way to reach the market.",
    shortDescription: "Transform market intelligence into practical growth strategies that support expansion, product launches, and long-term business development.",
    icon: <FaRocket size={24} />,
    image: GTMGrowthVisual,
    whatWeGive: "Researchwire helps organizations transform market intelligence into practical growth strategies that support expansion, product launches, and long-term business development.",
    heroCtaText: "Talk to Our Experts",
    bentoGridTitle: "Building Your Growth Strategy",
    closingSection: {
      title: "From Insight to Execution Planning",
      description: "We bring together insights from markets, customers, competitors, suppliers, and technology trends to create strategies that are practical, evidence-based, and aligned with your business objectives. Whether you're exploring international expansion, launching a new product, or entering a new industry, Researchwire helps you move forward with a clear, research-backed strategy.",
      ctaText: "Get in Touch",
      ctaLink: "/contact-us"
    },
    overviewPoints: [
      {
        title: "Every Growth Journey Is Different",
        text: "Our work is designed to help organizations answer questions such as:",
        bullets: [
          "Which markets should we prioritize?",
          "Which customer segments offer the greatest potential?",
          "How should we position our offering?",
          "What is the most effective route to market?",
          "Which partnerships or distribution channels should we consider?",
          "What factors could influence successful market entry?"
        ]
      }
    ],
    outputsSection: {
      title: "What the Strategy Covers",
      description: "The strategy brings together market, customer, competitor, channel, and partner insights to define where to compete and how to pursue growth.",
      items: [
        { title: "Market entry strategy frameworks", image: MarketEntryVisual },
        { title: "Target segment prioritization", image: TargetSegmentVisual },
        { title: "Value proposition development", image: ValuePropositionVisual },
        { title: "Channel and partnership assessments", image: ChannelPartnershipVisual },
        { title: "Structured growth roadmaps", image: StructuredGrowthVisual },
        { title: "Strategic milestone planning", image: StrategicMilestoneVisual }
      ]
    },
    detailedContent: [
      {
        title: "Market Entry Strategy",
        description: "Evaluate market attractiveness, entry barriers, competitive intensity, regulatory considerations, and recommended approaches for entering new markets."
      },
      {
        title: "Customer & Segment Prioritization",
        description: "Identify industries, customer groups, and applications that align most closely with your growth objectives."
      },
      {
        title: "Value Proposition & Positioning",
        description: "Develop differentiated market positioning based on customer needs, competitive dynamics, and market opportunities."
      },
      {
        title: "Channel & Partnership Strategy",
        description: "Assess distribution models, channel partners, strategic alliances, and ecosystem participants that can accelerate market access."
      },
      {
        title: "Growth Roadmap",
        description: "Translate market insights into a structured roadmap with clear priorities, milestones, and strategic recommendations."
      }
    ]
  },
  {
    slug: "custom-research-solutions",
    title: "Custom Research Solutions",
    description: "Research Designed Around Your Business Questions. Not every business challenge fits into a predefined research category. Organizations often need answers to unique questions that require a customized approach, multiple research methodologies, and industry-specific expertise.",
    shortDescription: "Bespoke market research engagements built around your unique objectives and complex business questions.",
    icon: <FaClipboardList size={24} />,
    image: CustomResearchVisual,
    isCustomLayout: true,
    whatWeGive: "Researchwire delivers bespoke market research engagements built around your objectives, providing the flexibility to address complex business questions that extend beyond standardized research reports.",
    heroCtaText: "Talk to Our Experts",
    closingSection: {
      title: "Let's Build a Research Approach Around Your Requirements",
      description: "If your research needs don't fit into a standard service, we'd be happy to discuss your objectives and develop a customized engagement aligned with your business priorities.",
      ctaText: "Get in Touch",
      ctaLink: "/contact-us"
    },
    customOverview: {
      title: "No Two Research Engagements Are the Same",
      description: "Some organizations need to evaluate a new market. Others need to identify suppliers, validate customer demand, benchmark competitors, or assess emerging technologies. Rather than forcing every project into a predefined framework, we build each engagement around the decisions you need to make.",
      image: CustomResearchSecondaryVisual
    },
    customComplexDecisions: {
      title: "Designed for Complex Business Decisions",
      description: "Organizations partner with Researchwire when they need answers that cannot be found in published reports or off-the-shelf studies. Whether the requirement involves multiple industries, emerging technologies, niche markets, or highly specific business questions, we develop a research approach that delivers relevant, decision-ready insights."
    },
    customProcess: {
      title: "How We Build the Research",
      description: "Every project begins with understanding the business problem rather than selecting a research methodology. Together, we define:",
      bullets: [
        "The business questions to be answered",
        "The scope of research",
        "Target markets and industries",
        "Information requirements",
        "Appropriate research methodologies",
        "Expected outputs and deliverables"
      ]
    },
    customCapabilities: {
      title: "Designed Around Your Research Requirements",
      description: "The scope, methodology, and deliverables are defined around the business questions, target markets, information requirements, and decisions the research needs to support. Depending on the requirement, an engagement may combine:",
      tags: [
        "Market assessment",
        "Competitive intelligence",
        "Customer research",
        "Supplier intelligence",
        "Technology & innovation analysis",
        "Growth strategy support",
        "Commercial due diligence"
      ]
    }
  }
];
